import instanciaAxios from '../../miscelaneo/instanciaAxios';
import InputCatalogoCuentas from '../util/Inputs/InputCatalogoCuentas';

const FuncionesMantenimientoEntidad = () => {

    async function ObtenerEntidadDetallada(id_entidad) {
        try {
          const respuesta = await instanciaAxios.get(`/entidad/${id_entidad}`);
      
          if (respuesta.data && Object.keys(respuesta.data).length > 0) {
            return respuesta.data;
          } else {
            throw new Error("No se encontraron datos para esta entidad.");
          }
        } catch (error) {
          console.error("Error al obtener los datos:", error.message);
          throw error; // Volvemos a lanzar el error para que el que llame esta función pueda capturarlo.
        }
      }

      
      function ObtenerPayload(formData) {
        const convertirANull = (valor) => {
            if (typeof valor === 'string' && valor.trim() === '') return null;
            return valor === '' || valor === 0 || valor === undefined || valor === null ? null : valor;
        };
    
        const payload = {
            nombre: convertirANull(typeof formData.nombre === 'string' ? formData.nombre.trim() : formData.nombre),
            apellido: convertirANull(typeof formData.apellido === 'string' ? formData.apellido.trim() : formData.apellido),
            razon_social: convertirANull(typeof formData.razon_social === 'string' ? formData.razon_social.trim() : formData.razon_social),
            correo: convertirANull(formData.correo),
            rnc: convertirANull(formData.rnc),
            cedula: convertirANull(formData.cedula),
            pasaporte: convertirANull(formData.pasaporte),
            telefono: convertirANull(formData.telefono),
            celular: convertirANull(formData.celular),
            whatsapp: convertirANull(formData.whatsapp),
            fecha_nacimiento: convertirANull(formData.fecha_nacimiento?.trim()),
            comentario: convertirANull(formData.comentario),
            id_sexo: convertirANull(parseInt(formData.id_sexo)),
            id_pais: convertirANull(parseInt(formData.id_pais)),
    
            direccion_id_tipo_direccion: convertirANull(parseInt(formData.direccion_id_tipo_direccion)),
            direccion_id_municipio: convertirANull(parseInt(formData.direccion_id_municipio)),
            direccion_linea_uno: convertirANull(formData.direccion_linea_uno),
            direccion_linea_dos: convertirANull(formData.direccion_linea_dos),
            direccion_comentario: convertirANull(formData.direccion_comentario),

            contacto_nombre: convertirANull(formData.contacto_nombre),
            contacto_telefono: convertirANull(formData.contacto_telefono),
            contacto_correo: convertirANull(formData.contacto_correo),

            cuentas_banco: [
                formData.cuenta_banco_1_id_banco ? {
                    id_banco: parseInt(formData.cuenta_banco_1_id_banco),
                    id_tipo_cuenta_banco: parseInt(formData.cuenta_banco_1_id_tipo_cuenta),
                    numero_cuenta: formData.cuenta_banco_1_numero_cuenta,
                    id_cuenta_banco_entidad: formData.cuenta_banco_1_id_cuenta_banco_entidad || null
                } : null,
                formData.cuenta_banco_2_id_banco ? {
                    id_banco: parseInt(formData.cuenta_banco_2_id_banco),
                    id_tipo_cuenta_banco: parseInt(formData.cuenta_banco_2_id_tipo_cuenta),
                    numero_cuenta: formData.cuenta_banco_2_numero_cuenta,
                    id_cuenta_banco_entidad: formData.cuenta_banco_2_id_cuenta_banco_entidad || null
                } : null,
                formData.cuenta_banco_3_id_banco ? {
                    id_banco: parseInt(formData.cuenta_banco_3_id_banco),
                    id_tipo_cuenta_banco: parseInt(formData.cuenta_banco_3_id_tipo_cuenta),
                    numero_cuenta: formData.cuenta_banco_3_numero_cuenta,
                    id_cuenta_banco_entidad: formData.cuenta_banco_3_id_cuenta_banco_entidad || null
                } : null,
            ].filter(Boolean),

            tipos_entidad: formData.tipos_entidad?.map((id) => convertirANull(parseInt(id))) || null,
    
        detallesCliente: {
            descuento: convertirANull(parseFloat(formData.descuento)),
            limite_credito: convertirANull(parseFloat(formData.limite_credito_cliente)),
            limite_dias_credito: convertirANull(parseInt(formData.limite_dias_credito)),
            tipo_cliente: convertirANull(formData.tipo_cliente),
            id_tipo_comprobante_fiscal: convertirANull(parseInt(formData.id_tipo_comprobante_fiscal_cliente)),
            id_lista_precio: convertirANull(parseInt(formData.id_lista_precio)),
            id_cuenta_contable_debito: convertirANull(parseInt(formData.id_cuenta_contable_debito_cliente)),
            id_cuenta_contable_credito: convertirANull(parseInt(formData.id_cuenta_contable_credito_cliente))
        },
    
        detallesProveedor: {
            id_cuenta_contable_debito: convertirANull(parseInt(formData.id_cuenta_contable_debito_proveedor)),
            id_cuenta_contable_credito: convertirANull(parseInt(formData.id_cuenta_contable_credito_proveedor)),
            limite_credito: convertirANull(parseFloat(formData.limite_credito_proveedor)),
            es_informal: formData.es_informal
        },
    
            detallesEmpleado: {
                id_puesto: convertirANull(Number(formData.id_puesto)),
                fecha_contratacion: convertirANull(formData.fecha_contratacion?.trim()),
                fecha_salida: convertirANull(formData.fecha_salida?.trim()),
                fecha_vencimiento_licencia_conducir: convertirANull(formData.fecha_vencimiento_licencia_conducir?.trim()),
                id_cuenta_contable_debito: convertirANull(Number(formData.id_cuenta_contable_debito_empleado)),
                id_cuenta_contable_credito: convertirANull(Number(formData.id_cuenta_contable_credito_empleado)),
                id_sucursal: convertirANull(Number(formData.id_sucursal)),
                sueldo: {
                    sueldo_mensual: convertirANull(parseFloat(formData.sueldo_mensual)),
                    sueldo_x_hora: convertirANull(parseFloat(formData.sueldo_x_hora)),
                    incentivo_mensual: convertirANull(parseFloat(formData.incentivo_mensual)),
                    horas_diarias: convertirANull(parseFloat(formData.horas_diarias)),
                    aporte_extra: convertirANull(parseFloat(formData.aporte_extra)),
                    porcentaje_comision_x_venta: convertirANull(parseFloat(formData.porcentaje_comision_x_venta)),
                    porcentaje_comision_beneficio: convertirANull(parseFloat(formData.porcentaje_comision_beneficio)),
                    ISR: convertirANull(formData.isr),
                    AFP: formData.afp,
                    SFS: formData.sfs
                }
            }
        };
    
        if (formData.id_entidad) {
            payload.id_entidad = convertirANull(parseInt(formData.id_entidad));
        }
    
        return payload;
    }

    
  const generarCamposFormulario = (sexos, paises, tipos_comprobantes_fiscales, listas_precio, nombresCuentas, puestos, sucursales, tipos_direccion, bancos, tipos_cuenta_banco, provincias, municipios) =>

    [
    
    // campos de informacion general--------------------------------------------------------------------------------------------------
    { id: "nombre", type: "text", label: "Nombre", placeholder: "Nombre", seccion: "Información General", required: true },
    { id: "apellido", type: "text", label: "Apellido", placeholder: "Apellido", seccion: "Información General", required: false },
    { id: "razon_social", type: "text", label: "Razón Social", placeholder: "Razón Social", seccion: "Información General", required: false },
    { id: "correo", type: "email", label: "Correo Electrónico", placeholder: "Correo", seccion: "Información de Contacto", required: false },
    { id: "rnc", type: "text", label: "RNC", placeholder: "RNC", seccion: "Información General", required: false },
    { id: "cedula", type: "text", label: "Cédula", placeholder: "Cédula", seccion: "Información General", required: false },
    { id: "pasaporte", type: "text", label: "Pasaporte", placeholder: "Pasaporte", seccion: "Información General", required: false },
    { id: "telefono", type: "text", label: "Teléfono", placeholder: "Teléfono", seccion: "Información de Contacto", required: false },
    { id: "celular", type: "text", label: "Celular", placeholder: "Celular", seccion: "Información de Contacto", required: false },
    { id: "whatsapp", type: "text", label: "WhatsApp", placeholder: "WhatsApp", seccion: "Información de Contacto", required: false },
    { id: "fecha_nacimiento", type: "date", label: "Fecha de Nacimiento", placeholder: "Fecha de Nacimiento", seccion: "Información General", required: false },
    { id: "comentario", tipo_componente: "textarea", label: "Comentario", placeholder: "Comentario", seccion: "Comentario", required: false },

    {
      id: "id_sexo",
      label: "Sexo",
      type: "select",
      tipo_componente: "select",
      opciones: sexos.map(sexo => ({ label: sexo.descripcion, value: sexo.id_sexo })),
      seccion: "Información General",
      required: false
    },
    {
      id: "id_pais",
      label: "País de Origen",
      type: "select",
      tipo_componente: "select",
      opciones: paises.map(pais => ({ label: pais.descripcion, value: pais.id_pais })),
      seccion: "Información General",
      required: false
    },


    // campos de Cliente----------------------------------------------------------------------------------------------------

    { id: "descuento", type: "number", label: "Descuento (%)", placeholder: "Descuento (%)", seccion: "Datos de Cliente", tab: "cliente", required: false },
    { id: "limite_credito_cliente", type: "number", label: "Límite de Crédito", placeholder: "Límite de Crédito", seccion: "Datos de Cliente", tab: "cliente", required: false },
    { id: "limite_dias_credito", type: "number", label: "Límite de Días de Crédito", placeholder: "Límite de Días de Crédito", seccion: "Datos de Cliente", tab: "cliente", required: false },
    {
      id: "tipo_cliente",
      label: "Tipo de Cliente",
      type: "select",
      tipo_componente: "select",
      opciones: [
        { label: "Físico", value: "fisico" },
        { label: "Jurídico", value: "juridico" }
      ],
      seccion: "Datos de Cliente",
      tab: "cliente",
      required: true
    },
    {
      id: "id_tipo_comprobante_fiscal_cliente",
      label: "Tipo Comprobante Fiscal",
      type: "select",
      tipo_componente: "select",
      opciones: tipos_comprobantes_fiscales
        .filter(tipo => [1, 2, 8, 9, 10].includes(tipo.id_tipo_comprobante_fiscal))
        .map(tipo => ({ label: tipo.descripcion, value: tipo.id_tipo_comprobante_fiscal })),
      seccion: "Datos de Cliente",
      tab: "cliente",
      required: true
    },
    {
      id: "id_lista_precio",
      label: "Lista de Precios",
      type: "select",
      tipo_componente: "select",
      opciones: listas_precio.map(lista => ({ label: lista.descripcion, value: lista.id_lista_precio })),
      seccion: "Datos de Cliente",
      tab: "cliente",
      required: false
    },
    {
      id: "id_cuenta_contable_debito_cliente",
      label: "Cuenta Contable Débito (CxC)",
      seccion: "Contabilidad",
      tab: "cliente",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_debito_cliente"]}
          placeholder="Seleccionar Cuenta Débito (CxC)" 
        />
      )

    },
    {
      id: "id_cuenta_contable_credito_cliente",
      label: "Cuenta Contable Crédito (Ingresos)",
      seccion: "Contabilidad",
      tab: "cliente",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_credito_cliente"]}
          placeholder="Seleccionar Cuenta Crédito (Ingresos)" 
        />
      )

    },
    //CAMPOS DE PROVEEDOR----------------------------------------------------------------------------------------------------

    {
      id: "id_cuenta_contable_debito_proveedor",
      label: "Cuenta Contable Débito (CxP)",
      seccion: "Contabilidad",
      tab: "proveedor",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_debito_proveedor"]}
          placeholder="Seleccionar Cuenta Débito (CxP)" 
        />
      )

    },
    {
      id: "id_cuenta_contable_credito_proveedor",
      label: "Cuenta Contable Crédito (Gastos)",
      seccion: "Contabilidad",
      tab: "proveedor",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_credito_proveedor"]}
          placeholder="Seleccionar Cuenta Crédito (Gastos)" 
        />
      )

    },
    { id: "limite_credito_proveedor", type: "number", label: "Límite de Crédito", placeholder: "Límite de Crédito", seccion: "Datos de Proveedor", tab: "proveedor", required: false },
    {
      id: "es_informal",
      label: "Formalidad",
      type: "select",
      tipo_componente: "select",
      opciones: [
          {label: 'Formal', value: false},
          {label: 'Informal', value: true},

      ],
      seccion: "Datos de Proveedor",
      tab: "proveedor",
      required: true
    },

    //CAMPOS de empleado---------------------------------------------------------------------------------------
    { id: "fecha_contratacion", type: "date", label: "Fecha de Contratación", placeholder: "Fecha de Contratación", seccion: "Datos de Empleado", tab: "empleado", required: false },
    { id: "fecha_salida", type: "date", label: "Fecha de Salida", placeholder: "Fecha de Salida", seccion: "Datos de Empleado", tab: "empleado", required: false },
    { id: "fecha_vencimiento_licencia_conducir", type: "date", label: "Fecha Venc. Lic. Conducir", placeholder: "Fecha Venc. Lic. Conducir", seccion: "Datos de Empleado", tab: "empleado", required: false },
    {
      id: "id_puesto",
      label: "Puesto",
      type: "select",
      tipo_componente: "select",
      opciones: puestos.map(puesto => ({ label: puesto.descripcion, value: puesto.id_puesto })),
      seccion: "Datos de Empleado",
      tab: "empleado",
      required: false
    },
    {
      id: "id_sucursal",
      label: "Sucursal",
      type: "select",
      tipo_componente: "select",
      opciones: sucursales.map(sucursal => ({ label: sucursal.descripcion, value: sucursal.id_sucursal })),
      seccion: "Datos de Empleado",
      tab: "empleado",
      required: true
    },
    
    {
      id: "id_cuenta_contable_debito_empleado",
      label: "Cuenta Contable Débito (Gastos)",
      seccion: "Contabilidad",
      tab: "empleado",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_debito_empleado"]}
          placeholder="Seleccionar Cuenta Contable Débito (Gastos)" 
        />
      )

    },

    {
      id: "id_cuenta_contable_credito_empleado",
      label: "Cuenta Contable Crédito (CxP)",
      seccion: "Contabilidad",
      tab: "empleado",
      required: false,
      custom: (valorActual, onClickAbrirModal) => (
        <InputCatalogoCuentas
          valor={valorActual}
          onClick={onClickAbrirModal}
          nombreCuenta={nombresCuentas["id_cuenta_contable_credito_empleado"]}
          placeholder="Seleccionar Cuenta Contable Crédito (CxP)" 
        />
      )

    },
    { id: "sueldo_mensual", type: "number", label: "Sueldo Mensual", placeholder: "Sueldo Mensual", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "sueldo_x_hora", type: "number", label: "Sueldo por Hora", placeholder: "Sueldo por Hora", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "incentivo_mensual", type: "number", label: "Incentivo Mensual", placeholder: "Incentivo Mensual", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "horas_diarias", type: "number", label: "Horas Diarias", placeholder: "Horas Diarias", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "aporte_extra", type: "number", label: "Aporte Extra", placeholder: "Aporte Extra", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "porcentaje_comision_x_venta", type: "number", label: "% de Comisión por Venta", placeholder: "% de Comisión por Venta", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "porcentaje_comision_beneficio", type: "number", label: "% de Comisión por Beneficio", placeholder: "% de Comisión por Beneficio", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "isr", type: "number", label: "ISR", placeholder: "ISR", seccion: "Sueldo", tab: "empleado", required: false },
    { id: "afp", 
      type: "number", 
      label: "AFP", 
      placeholder: "AFP", 
      seccion: "Sueldo", 
      tab: "empleado",
      tipo_componente: 'select',
      opciones: [
        {label: 'Si', value: true},
        {label: 'No', value: false},

    ],
      required: true
    },
    { id: "sfs", 
      type: "number", 
      label: "SFS", 
      placeholder: "SFS", 
      seccion: "Sueldo", 
      tab: "empleado",
      tipo_componente: 'select',
      opciones: [
        {label: 'Si', value: true},
        {label: 'No', value: false},

    ],
      required: true
    },



  
    // CAMPOS DE DIRECCIÓN ---------------------------------------------------------------------------------
    { id: "direccion_id_tipo_direccion", tipo_componente: "select", label: "Tipo de Dirección",
      opciones: tipos_direccion.map(t => ({ label: t.descripcion, value: t.id_tipo_direccion })),
      seccion: "Dirección", required: false },
    { id: "direccion_id_pais", tipo_componente: "select", label: "País (Dirección)",
      opciones: paises.map(p => ({ label: p.descripcion, value: p.id_pais })),
      seccion: "Dirección", required: false },
    { id: "direccion_id_provincia", tipo_componente: "select", label: "Provincia",
      opciones: provincias.map(p => ({ label: p.descripcion, value: p.id_provincia })),
      seccion: "Dirección", required: false },
    { id: "direccion_id_municipio", tipo_componente: "select", label: "Municipio",
      opciones: municipios.map(m => ({ label: m.descripcion, value: m.id_municipio })),
      seccion: "Dirección", required: false },
    { id: "direccion_linea_uno", type: "text", label: "Línea 1", placeholder: "Calle, número, sector", seccion: "Dirección", required: false },
    { id: "direccion_linea_dos", type: "text", label: "Línea 2", placeholder: "Apartamento, unidad", seccion: "Dirección", required: false },
    { id: "direccion_comentario", type: "text", label: "Comentario Dirección", placeholder: "Comentario", seccion: "Dirección", required: false },

    // CAMPOS DE CONTACTO ---------------------------------------------------------------------------------
    { id: "contacto_nombre", type: "text", label: "Nombre del Contacto", placeholder: "Nombre del contacto", seccion: "Contacto", required: false },
    { id: "contacto_telefono", type: "text", label: "Teléfono del Contacto", placeholder: "Teléfono del contacto", seccion: "Contacto", required: false },
    { id: "contacto_correo", type: "email", label: "Correo del Contacto", placeholder: "Correo del contacto", seccion: "Contacto", required: false },

    // CAMPOS DE CUENTAS BANCARIAS (3 slots fijos) --------------------------------------------------------
    { id: "cuenta_banco_1_id_banco", tipo_componente: "select", label: "Banco 1",
      opciones: bancos.map(b => ({ label: b.descripcion, value: b.id_banco })),
      seccion: "Cuenta Bancaria 1", required: false },
    { id: "cuenta_banco_1_id_tipo_cuenta", tipo_componente: "select", label: "Tipo Cuenta 1",
      opciones: tipos_cuenta_banco.map(t => ({ label: t.descripcion, value: t.id_tipo_cuenta_banco })),
      seccion: "Cuenta Bancaria 1", required: false },
    { id: "cuenta_banco_1_numero_cuenta", type: "text", label: "Número Cuenta 1", placeholder: "Número de cuenta", seccion: "Cuenta Bancaria 1", required: false },

    { id: "cuenta_banco_2_id_banco", tipo_componente: "select", label: "Banco 2",
      opciones: bancos.map(b => ({ label: b.descripcion, value: b.id_banco })),
      seccion: "Cuenta Bancaria 2", required: false },
    { id: "cuenta_banco_2_id_tipo_cuenta", tipo_componente: "select", label: "Tipo Cuenta 2",
      opciones: tipos_cuenta_banco.map(t => ({ label: t.descripcion, value: t.id_tipo_cuenta_banco })),
      seccion: "Cuenta Bancaria 2", required: false },
    { id: "cuenta_banco_2_numero_cuenta", type: "text", label: "Número Cuenta 2", placeholder: "Número de cuenta", seccion: "Cuenta Bancaria 2", required: false },

    { id: "cuenta_banco_3_id_banco", tipo_componente: "select", label: "Banco 3",
      opciones: bancos.map(b => ({ label: b.descripcion, value: b.id_banco })),
      seccion: "Cuenta Bancaria 3", required: false },
    { id: "cuenta_banco_3_id_tipo_cuenta", tipo_componente: "select", label: "Tipo Cuenta 3",
      opciones: tipos_cuenta_banco.map(t => ({ label: t.descripcion, value: t.id_tipo_cuenta_banco })),
      seccion: "Cuenta Bancaria 3", required: false },
    { id: "cuenta_banco_3_numero_cuenta", type: "text", label: "Número Cuenta 3", placeholder: "Número de cuenta", seccion: "Cuenta Bancaria 3", required: false },
  ];

  function limpiarCampos(camposFormulario, setFormData,setTabsActivos, setNombresCuentas){
    const initialData = {};
    camposFormulario.forEach(campo => {
      initialData[campo.id] = '';
    });
    initialData.tipos_entidad = [];
    setFormData(initialData);
    setTabsActivos({
      general:true,
      cliente:false,
      proveedor:false,
      empleado:false,
    //  anexos:false
    });

    setNombresCuentas({})
  };

  
  return { ObtenerEntidadDetallada, ObtenerPayload, generarCamposFormulario, limpiarCampos };
};

export default FuncionesMantenimientoEntidad;
